import { createFileRoute } from '@tanstack/react-router';
import { CatalogoIntegracoesPage } from '@/components/integracoes/catalogo-page';

export const Route = createFileRoute('/_app/configuracoes/integracoes/')({
  component: CatalogoIntegracoesRota,
});

function CatalogoIntegracoesRota() {
  return <CatalogoIntegracoesPage />;
}
